import React from 'react';
import CardForm from "./components/CardForm";
import CardActions from "./components/CardActions";
import { CardProvider, useCardContext } from "./contexts/CardContext";

function MainContent() {
    const { cardNumber } = useCardContext();
    return cardNumber ? <CardActions /> : <CardForm />;
}

export default function App() {
    return (
        <CardProvider>
            <MainContent />
        </CardProvider>
    );
}